"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const CommentModal_1 = tslib_1.__importDefault(require("src/components/modal/CommentModal"));
const RequiredMessage = (props) => {
    return ((0, jsx_runtime_1.jsx)(CommentModal_1.default, { closeModal: () => props.setShowRequiredMessage(false), saveComments: async (message) => props.send(message), buttonText: props.buttonText || 'გაგზავნა', buttonColorType: 'danger' }));
};
exports.default = RequiredMessage;
